export default () => {
  function init() {
    const video = document.querySelector('.disco-drop video')
    if (video !== null) {
      addEventListeners();
    }
  }

  function addEventListeners() {
    window.addEventListener('load', mobileHeroHeight);
    window.addEventListener("resize", mobileHeroHeight);
    const unmute = document.querySelector('.hero-sound');
    unmute.addEventListener('click', videoSound);
  }

  function videoSound() {
    var video = document.querySelector('.disco-drop .hero-image__video--desktop video');
    if (window.innerWidth < 900) {
      video = document.querySelector('.disco-drop .hero-image__video--mobile video');
    }
    if(video.muted == true) {
      video.muted = false;
    } else {
      video.muted = true;
    }
  }

  function mobileHeroHeight() {
    const header = document.querySelector(".site-header");
    const localizationBar = document.querySelector(".localization-bar");
    const notificationBar = document.querySelector(".notification-bar");
    const marquee = document.querySelector(".marquee");

    const headerHeight = (header != null) ? header.offsetHeight : 0;
    const localizationBarHeight = (localizationBar != null) ? localizationBar.offsetHeight : 0;
    const notificationBarHeight = (notificationBar != null) ? notificationBar.offsetHeight : 0;
    const marqueeHeight = (marquee != null) ? marquee.offsetHeight : 0;
    // const discoContainer = document.querySelector(".disco-drop__container");
    const hero = document.querySelector(".disco-drop .hero-image");
    if (hero !== null) {
      hero.style.height = `calc(100vh - ${headerHeight + localizationBarHeight + notificationBarHeight + marqueeHeight}px)`;
    }
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
